<template>
  <div class="uk-card uk-card-default uk-padding">
    <div class="uk-text-center">
<!--      <div v-if="!showTimer">-->
      <div v-if="true">
        <div class="uk-margin uk-text-large">
          {{ local_page_keys.label_you_can_take_a_new_order }}
        </div>
        <div v-if="downtime.is_orders_to_work" class="uk-width-large uk-margin-auto uk-margin-top">
          <button type="button" class="uk-button uk-button-success tm-light" @click="getNewOrder()" :disabled="loading">
            {{ local_page_keys.button_get_a_new_order }}
            <span v-if="loading" class="uk-icon uk-spinner uk-margin-left" data-uk-spinner></span>
          </button>
        </div>
        <div v-else class="uk-width-large uk-margin-auto uk-margin-top">
          <button disabled class="tm-button-grey uk-button">
            {{ local_page_keys.button_no_orders_in_the_queue }}
          </button>
        </div>
        <div class="uk-margin-auto uk-margin-top">
          <CountNewOrdersPro :role="role"
                             :new_orders_count="children_new_orders_count"
                             :local_page_keys="local_page_keys"/>
        </div>
      </div>
      <div v-else>
        <!--временно скрыт RA-501 -->
        <div v-if="false" class="uk-margin uk-text-large">
          <h1>
            {{ local_page_keys.label_you_have_accepted_the_order }}
          </h1>
          <span v-if="orderdays >= 1"> {{ orderdays ? orderdays : 0 }} {{ local_page_keys.label_timer_days }}</span>
          <span v-if="orderdays < 1 && hours >= 1"> {{ hours ? hours : 0 }} {{
              local_page_keys.label_timer_hours
            }} </span>
          <span v-else-if="orderdays >= 1"> {{ hours ? hours : 0 }} {{ local_page_keys.label_timer_hours }} </span>
          <span> {{ minutes ? minutes : 0 }} {{ local_page_keys.label_timer_minutes }} </span>
          <span> {{ seconds ? seconds : 0 }} {{ local_page_keys.label_timer_seconds }}</span>
          <span> {{ local_page_keys.button_back }} </span>
        </div>
        <div v-if="downtime.is_orders_to_work !== false" class="uk-width-large uk-margin-auto uk-margin-top">
          <button type="button" class="uk-button uk-button-success tm-light" @click="getNewOrder()" :disabled="loading">
            {{ local_page_keys.button_get_a_new_order }}
            <span v-if="loading" class="uk-icon uk-spinner uk-margin-left" data-uk-spinner></span>
          </button>
        </div>
        <div v-else class="uk-width-large uk-margin-auto uk-margin-top">
          <button disabled class="tm-button-grey uk-button">
            {{ local_page_keys.button_no_orders_in_the_queue }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CountNewOrdersPro from "@/pages/Dashboard/Components/CountNewOrdersPro";

export default {
  name: "ProRetouchersInactivityTimer",
  props: {
    downtime: {},
    new_orders_count: {
      type: Number,
    }
  },
  components: {
    CountNewOrdersPro,
  },
  data: () => ({
    orderdays: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    showTimer: false,
    interval: null,
    interval2: null,
    orderDateTime: null,
    local_page_keys: {},
    orderCurrDate: null,
    role: '',
    //countdown: 100,
    intervalId: null,
    loading: false
  }),
  watch: {
    // 'downtime.telegram_code.unix_time': function (newUnixTime, oldUnixTime) {
    //   if (newUnixTime !== oldUnixTime) {
    //     // Обновляем счетчик обратного отсчета
    //     this.countdown = 100;
    //     // Перезапускаем счетчик
    //     clearInterval(this.intervalId);
    //     this.startCountdown();
    //   }
    // },
  },
  computed: {
    children_new_orders_count() {
      return this.new_orders_count;
    },
    // formattedTimeTgCode() {
    //   const minutes = Math.floor(this.countdown / 60);
    //   const seconds = this.countdown % 60;
    //   // Форматируем минуты и секунды как двузначные числа
    //   const formattedMinutes = String(minutes).padStart(2, '0');
    //   const formattedSeconds = String(seconds).padStart(2, '0');
    //
    //   return `${formattedMinutes}:${formattedSeconds}`;
    // }
  },
  methods: {
    diffOrderMinutes(data) {
      let orderDate = this.orderDateTime !== null ? this.orderDateTime : Date.now();
      this.showTimer = (orderDate === this.orderDateTime ? true : false);
      let diff = this.orderCurrDate - orderDate;
      if (data === 'minutes') {
        return Math.floor((diff % 3.6e6) / 6e4);
      } else if (data === 'hours') {
        let hours = Math.floor(diff / 3.6e6);
        if (hours > 24) {
          let days = Math.floor(hours / 24);
          hours = hours - 24 * days;
        }
        return hours;
      } else if (data === 'seconds') {
        return Math.floor((diff % 60000) / 1000);
      } else if (data === 'days') {
        let hours = Math.floor(diff / 3.6e6);
        return Math.floor(hours / 24);
      }
    },
    async getNewOrder() {
      let msg = this.local_page_keys.alert_are_you_sure_you_want_to_take_on_a_new_order;

      if (confirm(msg)) {
        this.loading = true;
        this.$emit('is-loading', true);
        let data;
        let params = {role:'pro-retoucher'};
        if((this.$route.path).indexOf('orderCheckEducation') > 0) params['education'] = 'education';
        if (this.role === 'test-retoucher') {
          await this.$store.dispatch('order/getNewOrder', params);
        } else {
          await this.$store.dispatch("order/getNewOrder", params);
        }
        data = this.$store.getters["order/getNewOrder"];

        if (data.status === "ok") {
          this.$emit('retry', true);
        } else if(data.status === "error"){
          alert(data.message);
          this.$emit('is-loading', false);
          this.$emit('retry', true);
        } else {
          this.$emit('is-loading', false);
          this.$emit('retry', true);
        }
        this.loading = false;
      }
    },
    // copyTgCode(code) {
    //   if (code) {
    //     const input = document.createElement('input');
    //     input.value = code;
    //     document.body.appendChild(input);
    //     input.select();
    //     const successful = document.execCommand('copy');
    //     document.body.removeChild(input);
    //     if (successful) {
    //       UIkit.notification({
    //         message: this.local_page_keys.copy_telegram_code,
    //         pos: 'top-center',
    //         status: 'primary',
    //         timeout: 1500
    //       })
    //     }
    //   }
    // },
    // startCountdown() {
    //   this.intervalId = setInterval(() => {
    //     if (this.countdown > 0) {
    //       this.countdown--;
    //     } else {
    //       clearInterval(this.intervalId);
    //     }
    //   }, 1000); // Обновляем каждую секунду
    // },
  },
  async mounted() {
    this.local_page_keys = await this.$filtergetLocalisationPage('order-downtime');
    this.role = await this.$store.getters['profile/role'];
    this.showTimer = this.downtime.inactivity_timer_start !== null;
    if (this.downtime.inactivity_timer_start !== null) {
      this.orderCurrDate = Object.keys(this.downtime).includes('now') ? Date.parse(this.downtime.now) : Date.now();
      this.orderDateTime = Date.parse(this.downtime.inactivity_timer_start);
      this.interval = setInterval(() => {
        this.orderCurrDate += 1000;
        this.seconds = this.diffOrderMinutes('seconds');
        this.minutes = this.diffOrderMinutes('minutes');
        this.hours = this.diffOrderMinutes('hours');
        this.orderdays = this.diffOrderMinutes('days');
      }, 1000);
    }
    this.interval2 = setInterval(() => {
      this.$emit('retry', true);
    }, 5000);
    //this.startCountdown();
  },
  beforeDestroy() {
    clearInterval(this.interval);
    clearInterval(this.interval2);
  }

}
</script>